import React, { useState } from 'react';
import { auth } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import miLogo from './assets/mi-logo.png';
import toast, { Toaster } from 'react-hot-toast';

function LoginScreen() {
    const [isLoginView, setIsLoginView] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [displayName, setDisplayName] = useState('');

    const handleLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
            .catch(error => {
                console.error("Error detallado de login:", error); 
                if (error.code === 'auth/invalid-credential' || error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
                    toast.error("Email o contraseña incorrectos.");
                } else {
                    toast.error("Hubo un problema al iniciar sesión. Inténtalo de nuevo.");
                }
            });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (!displayName) {
            return toast.error("Por favor, introduce tu nombre.");
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(userCredential.user, {
                displayName: displayName
            });
        } catch (error) {
            if (error.code === 'auth/email-already-in-use') {
                toast.error("Este email ya está registrado. Intenta iniciar sesión.");
            } else {
                toast.error("Error al registrar. Asegúrate de que la contraseña tenga al menos 6 caracteres.");
            }
        }
    };

    return (
        <div className="min-h-screen bg-kokimiko-fondo flex flex-col justify-center items-center p-4">
            <Toaster position="top-center" />
            <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg border border-gray-100 text-center">
                {/* LOGO GIGANTE Y SIN RECORTES */}
                <img src={miLogo} alt="Logo Kokimiko" className="w-72 h-auto mx-auto mb-6 object-contain" />
                
                <h2 className="text-2xl font-bold text-kokimiko-texto mb-2">
                    {isLoginView ? 'Bienvenido de nuevo' : 'Crear una cuenta'}
                </h2>
                <p className="text-gray-500 mb-6">
                    {isLoginView ? 'Ingresa tus credenciales para continuar' : 'Completa tus datos para registrarte'}
                </p>

                <form onSubmit={isLoginView ? handleLogin : handleRegister} className="space-y-4">
                    {!isLoginView && (
                        <input
                            type="text"
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value)}
                            placeholder="Nombre Completo"
                            required
                            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-kokimiko-azul transition-all"
                        />
                    )}
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-kokimiko-azul transition-all"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Contraseña"
                        required
                        className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-kokimiko-azul transition-all"
                    />
                    <button type="submit" className="w-full bg-kokimiko-azul text-white font-bold py-3 rounded-lg hover:bg-kokimiko-morado transition-colors shadow-md">
                        {isLoginView ? 'Iniciar Sesión' : 'Registrarse'}
                    </button>
                </form>

                <p className="mt-6 text-sm text-gray-600">
                    {isLoginView ? '¿No tienes cuenta?' : '¿Ya tienes una cuenta?'}
                    <button onClick={() => setIsLoginView(!isLoginView)} className="font-semibold text-kokimiko-rosa hover:text-kokimiko-verde hover:underline ml-1 transition-colors">
                        {isLoginView ? 'Regístrate aquí' : 'Inicia sesión'}
                    </button>
                </p>
            </div>
        </div>
    );
}

export default LoginScreen;